import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const StatCard = ({ title, value, trend, trendUp, alert }: any) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ fontSize: 13, color: "hsl(var(--muted-foreground))", fontWeight: 600 }}>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={{ fontSize: "1.8rem", fontWeight: 800, marginBottom: 10 }}>{value}</div>
        {trend ? (
          <div style={{ fontSize: 12, fontWeight: 600, color: trendUp ? "#34d399" : "#f87171" }}>
            {trendUp ? "▲" : "▼"} {trend}
            <span style={{ color: "hsl(var(--muted-foreground))", marginLeft: 6, fontWeight: 500 }}>vs last month</span>
          </div>
        ) : null}
        {alert ? (
          <div style={{ fontSize: 12, color: "#f59e0b", fontWeight: 600 }}>
            {alert}
            <span style={{ color: "hsl(var(--muted-foreground))", marginLeft: 6, fontWeight: 500 }}>High priority</span>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default StatCard;
